module.exports = __webpack_public_path__ + "static/Powder-room-mobile-94704522d9aa06d39fb758ab06062103.jpg";